import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import persistReducer from "redux-persist/es/persistReducer";
import storage from "redux-persist/lib/storage";
import { RootState } from "./store";

export enum UserRole {
    SuperAdmin = "SuperAdmin",
    Admin = "Admin",
    User = "User",
    Checker = "Checker",
    Maker = "Maker",
    None = ""
}


export interface authData {
    token: string,
    expiration: string,
    refreshToken: string,
    refreshTokenExpiration: string,
    userName: string,
    role: UserRole,
    institutionName: string,
}

const initialState = {
    token: '',
    expiration: '',
    refreshToken: '',
    refreshTokenExpiration: '',
    userName: '',
    role: UserRole.None,
    institutionName: '',
} satisfies authData as authData

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setCredentials: (state: authData, action: PayloadAction<authData>) => {
            state.userName = action.payload.userName
            state.token = action.payload.token
            state.refreshToken = action.payload.refreshToken
            state.refreshTokenExpiration = action.payload.refreshTokenExpiration
            state.expiration = action.payload.expiration
            state.role = action.payload.role
            state.institutionName = action.payload.institutionName
        },

        logOut: (state: authData) => {
            state.userName = ''
            state.token = ''
            state.refreshToken = ''
            state.expiration = ''
            state.refreshTokenExpiration = ''
            state.role = UserRole.None
            state.institutionName = ''
        },

    }
})

export const { setCredentials, logOut } = authSlice.actions
export default authSlice.reducer

const persistConfig = {
    key: 'auth',
    version: 1,
    storage,
    blacklist: ['auth'],

}

export const persistedAuthReducer = persistReducer(persistConfig, authSlice.reducer)

export const CurrentUserRole = (state: RootState) => state.auth.role; 